import React, { createContext, useContext, useState } from "react";

type ClickData = { 
  lat: number; 
  lon: number
  featureTypeName? : string; // e.g., "river", "lake", "reservoir"
  featureProperties? : { [key: string]: any };
 } | null;

const ClickContext = createContext<{
  clickData: ClickData;
  setClickData: React.Dispatch<React.SetStateAction<ClickData>>;
}>({
  clickData: null,
  setClickData: () => {},
});

export const ClickProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [clickData, setClickData] = useState<ClickData>(null);
  return (
    <ClickContext.Provider value={{ clickData, setClickData }}>
      {children}
    </ClickContext.Provider>
  );
};

export const useClickContext = () => useContext(ClickContext);